import { HostedFieldsField, HostedFieldsHostedFieldsFieldData, HostedFieldsHostedFieldsFieldName } from "braintree-web/modules/hosted-fields";
import { FieldName } from "react-hook-form";
import { ICreditCardData } from "Services/API/API";
import * as yup from "yup";

export function getBrainTreeFormModel(profile?: ICreditCardData) {
   return {
      fullName: profile?.fullName,
      address: profile?.address,
      city: profile?.city,
      country: profile?.country,
      state: profile?.state
   };
}

export type BrainTreeFormModel = ReturnType<typeof getBrainTreeFormModel>;

export type ExistingCardDetails = BrainTreeFormModel & {
   expirationDateRaw: string | undefined;
   zip: string | undefined;
}
//Somehow braintree dts is missing supportedCardBrands 
export type ExtendedHostedFieldsField = HostedFieldsField & {
   supportedCardBrands: object
}
export type BraintreeFieldNames = Exclude<HostedFieldsHostedFieldsFieldName, "expirationDateRaw">;
export type FieldValidationState = Omit<HostedFieldsHostedFieldsFieldData, "container" | "isFocused">;
export type FieldsValidationState = {
   [key in BraintreeFieldNames]: FieldValidationState
};

export const BrainTreeFormModelSchema: yup.SchemaOf<BrainTreeFormModel> = yup.object({
   fullName: yup.string().trim().required("Cardholder name is required").defined(),
   address: yup.string().trim().required("Address is required").defined(),
   city: yup.string().trim().required("City is required").defined(),
   country: yup.string().trim().required("Country is required").defined(),
   state: yup.string().trim().required("State is required").defined(),
}).defined();

export function getTypedKey(key: string): FieldName<BrainTreeFormModel> | undefined {
   if (key in getBrainTreeFormModel())
      return key as FieldName<BrainTreeFormModel>;
   else
      return undefined;
}